import {
  FormControlLabel,
  FormGroup,
  TextField,
  Checkbox,
  Grid,
} from "@mui/material";
import React from "react";

import HelperText from "../../../../components/feedback/helper-text";
import { language } from "../../../../language";
import { getUnitPropertie } from "../../../smart/camunda/forms/functions";
import { getPropertieObjectById } from "../helper";
import OnblurComponent from "../onBlur";

export default class DateModal {
  static DisplayTab(props) {
    const {
      onChange,
      onCheckChange,
      onPropertieChange,
      state,
      error,
    } = props;
    const toolTip = getUnitPropertie(state, "toolTip");
    const required = getUnitPropertie(state, "required");
    const readOnly = getUnitPropertie(state, "readOnly");
    const showField = getUnitPropertie(state, "showField");
    const hidden = getUnitPropertie(state, "hidden");
    const isRequired = getUnitPropertie(state, "isRequired");
    const fullWidth = getUnitPropertie(state, "fullWidth");
    const label = getUnitPropertie(state, "label");

    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onChange(event)}
            name="id"
            variant="outlined"
            id="id"
            label="Id"
            value={state.id || ""}
            fullWidth
            helperText={language.toolTipId}
          />
        </Grid>
        <Grid item size={12}>
          <TextField
            onChange={onPropertieChange}
            name="label"
            variant="outlined"
            id="label"
            label={language.propertieLabel}
            value={label || ""}
            fullWidth
            helperText={language.toolTipLabel}
          />
        </Grid>

        <Grid item size={12}>
          <TextField
            onChange={(event) => onChange(event)}
            name="description"
            variant="outlined"
            id="descricao"
            label={language.propertieDescription}
            value={state.description || ""}
            fullWidth
            helperText={language.toolTipDescription}
          />
        </Grid>

        <Grid item size={12}>
          <TextField
            onChange={(event) => onPropertieChange(event)}
            name="toolTip"
            variant="outlined"
            id="standard-basic"
            label={language.propertieToolTip}
            value={toolTip || ""}
            multiline
            rows="4"
            fullWidth
            helperText={language.toolTipToolTip}
          />
        </Grid>

        <Grid item size={12}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  name="isRequired"
                  onChange={(event) => onCheckChange(event)}
                  value={isRequired}
                  checked={isRequired || false}
                />
              }
              label={language.propertieRequired}
            />
          </FormGroup>
        </Grid>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onPropertieChange(event)}
            name="required"
            variant="outlined"
            id="standard-basic"
            label={language.propertieRequired}
            value={required || ""}
            disabled={!isRequired}
            error={!!getPropertieObjectById(error, "required")}
            fullWidth
          />
          {error && getPropertieObjectById(error, "required") && (
            <HelperText>{language.requirederror}</HelperText>
          )}
        </Grid>

        <Grid item size={12}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  name="readOnly"
                  onChange={(event) => onCheckChange(event)}
                  value={readOnly}
                  checked={readOnly || false}
                />
              }
              label={language.propertieReadonly}
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="showField"
                  onChange={(event) => onCheckChange(event)}
                  value={showField}
                  checked={showField || false}
                />
              }
              label={language.propertieShowfield}
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="hidden"
                  onChange={(event) => onCheckChange(event)}
                  value={hidden}
                  checked={hidden || false}
                />
              }
              label={language.propertieHidden}
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="fullWidth"
                  onChange={(event) => onCheckChange(event)}
                  value={fullWidth}
                  checked={fullWidth || false}
                />
              }
              label={language.propertieFullWidth}
            />
          </FormGroup>
        </Grid>
      </Grid>
    );
  }

  static ValidationTab(props) {
    const {
      onChange,
      onPropertieChange,
      onCheckChange,
      state,
      error,
    } = props;
    const regex = getUnitPropertie(state, "regex");
    const messageRegex = getUnitPropertie(state, "messageRegex");
    const futureDate = getUnitPropertie(state, "futureDate");

    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onChange(event)}
            name="value"
            variant="outlined"
            id="value"
            label={language.propertieDefaultValue}
            value={state.value || ""}
            type="date"
            InputLabelProps={{ shrink: true }}
            fullWidth
            helperText={language.toolTipDefaultValue}
          />
        </Grid>
        <OnblurComponent {...props} />

        <Grid item size={12}>
          <TextField
            onChange={(event) => onPropertieChange(event)}
            name="regex"
            variant="outlined"
            id="regex"
            label={language.propertieRegex}
            value={regex || ""}
            fullWidth
            helperText={language.toolTipRegex}
          />
        </Grid>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onPropertieChange(event)}
            name="messageRegex"
            variant="outlined"
            id="messageRegex"
            label={language.propertieRegexMessage}
            value={messageRegex || ""}
            error={!!getPropertieObjectById(error, "messageRegex")}
            fullWidth
            helperText={language.toolTipRegexMessage}
          />
          {error && getPropertieObjectById(error, "messageRegex") && (
            <HelperText>{language.requirederror}</HelperText>
          )}
        </Grid>
        <Grid item size={12}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  name="futureDate"
                  onChange={(event) => onCheckChange(event)}
                  value={futureDate}
                  checked={futureDate || false}
                />
              }
              label={language.propertieFutureDate}
            />
          </FormGroup>
        </Grid>
      </Grid>
    );
  }

  static StylesTab(props) {
    const { onPropertieChange, state, classes } = props;
    const propertieCSS = getUnitPropertie(state, "propertieCSS");

    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onPropertieChange(event)}
            name="propertieCSS"
            variant="outlined"
            id="standard-basic"
            label={language.propertieCSS}
            value={propertieCSS || ""}
            multiline
            rows="4"
            fullWidth
            helperText={language.toolTipCSS}
          />
        </Grid>
      </Grid>
    );
  }
}
